import React from "react"

import { Formik, Form, FieldArray } from "formik"
import * as yup from "yup"

import { Fieldset, Modal } from "components"

const BookingAdditionalProduct = ({ isOpen, onClose, onSubmit }) => {
  const productModel = {
    name: "",
    description: "",
    category: "Additional",
    quantity: 1,
    price: 0,
  }

  //   const userSchema = yup.object().shape({
  //     displayName: yup.string().required("Full name is reqiured"),
  //     email: yup
  //       .string()
  //       .email("E-mail is not valid!")
  //       .required("E-mail is required!"),
  //     password: yup.string(),
  //     // .required("Password name is reqiured"),
  //     phoneNumber: yup.string(),
  //     role: yup.object().shape({
  //       value: yup.string().required("Role is required"),
  //     }),
  //   })

  const formikProps = {
    initialValues: { products: [productModel] },
    validateOnBlur: false,
    validateOnChange: false,
    // validationSchema: userSchema,
    onSubmit: async (values, { props, resetForm, setErrors }) => {
      try {
        await onSubmit(values.products)
        // await onClose()
      } catch (error) {
        setErrors({ server: error?.graphQLErrors })
      }
    },
  }

  return (
    <Modal title="Add Aditional Product" isOpen={isOpen} onClose={onClose}>
      <div className="max-w-screen-lg mx-auto">
        <Formik {...formikProps}>
          {({ values, errors, isSubmitting }) => (
            <Form>
              <FieldArray
                name="products"
                render={(arrayHelpers) => (
                  <>
                    {values?.products.map((product, index) => (
                      <FieldProduct
                        key={index}
                        index={index}
                        {...product}
                        onDelete={() => arrayHelpers.remove(product.index)}
                      />
                    ))}
                  </>
                )}
              />

              <div className="py-3">
                {errors?.server?.map(({ code, message }) => (
                  <div role="alert">
                    <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                      {code}
                    </div>
                    <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                      <p>{message}</p>
                    </div>
                  </div>
                ))}
              </div>

              <ModalNavigation {...{ isSubmitting, onClose }} />
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default BookingAdditionalProduct

const ModalNavigation = ({ isSubmitting, onClose }) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
      <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <button
          disabled={isSubmitting}
          type="submit"
          className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
        >
          Save
        </button>
      </span>

      <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          onClick={onClose}
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Cancel
        </button>
      </span>
    </div>
  )
}

const FieldProduct = ({ index, onDelete }) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center">
        <div className="w-3/12 px-2 py-3 ">
          <Fieldset name={`products[${index}].name`} placeholder="Name" />
        </div>

        <div className="w-4/12 px-2 py-3 ">
          <Fieldset
            name={`products[${index}].description`}
            placeholder="Description"
          />
        </div>

        <div className="w-2/12 px-2 py-3 flex spaxe-x-1">
          <Fieldset
            name={`products[${index}].quantity`}
            type="quantity"
            placeholder="Quantity"
          />
        </div>

        <div className="w-2/12 px-2 py-3 ">
          <Fieldset name={`products[${index}].price`} type="price" />
        </div>

        <div className="w-1/12 px-2 py-3 ">
          {index === 0 ? null : (
            <button type="button" onClick={onDelete}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
